import React from 'react';
import projectData from '../data/project-data.json';
import ProjectCard from './ProjectCard';

const ProjectGrid = ({ filterTypes = [] }) => {
  return (
    <div className="container mx-auto">
      <div className="flex flex-wrap justify-center md:flex-row md:-mx-3">
        {projectData
          .filter(project => filterTypes.length === 0 || filterTypes.includes(project.type))
          .map(project => (
            <div key={project.name} className="flex-none px-3 w-full md:w-1/2">
              <ProjectCard project={project} />
            </div>
          ))}
      </div>
    </div>
  );
};
export default ProjectGrid;
